import { useCallback, useEffect, useMemo } from "react";

import createStore from "@Stores/base-factories";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useEmailTemplateFactory = ({ fetch, collection: { setItem, fetchById }, collections: { collectionsURL }, siteSelected: { id: siteId } }) => {
  const fetchTypeTemplate = useCallback(async typeTemplate => {
    const template = await fetch({
      method: 'get',
      url: `${collectionsURL}/getDefaultTemplate/${typeTemplate}`,
      params: { siteId },
    })

    setItem(template)
  }, [collectionsURL, fetch, setItem, siteId])

  return useMemo(() => ({
    useLoad: (id, typeTemplate) => {
      useEffect(() => {
        id && fetchById(id)
        typeTemplate && fetchTypeTemplate(typeTemplate)
      }, [id, typeTemplate])
    },
  }), [fetchById, fetchTypeTemplate])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('email-templates')
  .extendHookCollectionsFactory('email-templates')
  .extend(useEmailTemplateFactory)
  .factory()

export {
  Provider as EmailTemplateProvider,
  useStore as useEmailTemplateStore,
}
